<!-- The Protekta logo is lower than the Mobiliar one, keep the visual gap equal -->
<div
  class="mobi-ui-margin-t-lg view-enter-animation"
  [class]="platformService.isProtekta() ? 'smMax:!mt-1' : 'smMax:!mt-7'"
>
  @if (breadcrumb() && breadcrumb()!.length > 1) {
    <div class="mobi-ui-grid is-centered">
      <div class="mobi-ui-col-1/1 xl:mobi-ui-col-3/4">
        <nav #nav class="mobi-ui-breadcrumb-major is-trail" aria-label="Breadcrumb">
          @if (schema()) {
            <mobi-ld-schema [schema]="schema()" />
          }
          <ol #list>
            <li>
              <a
                [betterRouterLink]="breadcrumb()![0].url | extractUrl"
                class="flex items-baseline"
                aria-label="Home"
              >
                <span class="flex">
                  <mobi-ui-icon-major name="home" /> <span class="hidden">Home</span>
                </span>
              </a>
            </li>
            @for (
              breadcrumbItem of breadcrumb() | slice: 1;
              track index;
              let index = $index;
              let isCurrentRoute = $last
            ) {
              <li>
                <a
                  [betterRouterLink]="breadcrumbItem.url | extractUrl"
                  [attr.aria-current]="isCurrentRoute ? 'page' : null"
                  [attr.aria-label]="isCurrentRoute ? null : breadcrumbItem.title"
                  [attr.title]="isCurrentRoute ? null : breadcrumbItem.title"
                >
                  <span class="label">{{ breadcrumbItem.title }}</span>
                  @if (!isCurrentRoute) {
                    <span class="ellipsis" aria-hidden="true">…</span>
                  }
                </a>
              </li>
            }
          </ol>
        </nav>
      </div>
    </div>
  }
</div>
